import { MarketTypes } from 'api/types';
import fetcher from 'lib/fetcher';
import useSWRMutation from 'swr/mutation';

const useEstimateById = (marketType: MarketTypes | undefined, id: number | undefined) => {
  async function fetchEstimateSPrimary(url: string) {
    try {
      if (marketType && id) {
        const data = await fetcher(url);
        if (data?.error) {
          throw 'Не достаточно данных для автоматического расчета рыночной стоимости. Оставьте заявку и наш эксперт подготовит для вас расчет.';
        }
        return data.result;
      }
    } catch (error) {
      throw 'Не достаточно данных для автоматического расчета рыночной стоимости. Оставьте заявку и наш эксперт подготовит для вас расчет.';
    }
  }

  const endpoint =
    marketType === MarketTypes.PRIMARY
      ? `/facilities/estimate-primary/${id}`
      : `/facilities/estimate-secondary/${id}`;

  const { data, error, isMutating, trigger } = useSWRMutation(endpoint, fetchEstimateSPrimary);
  return { data, error, isMutating, trigger };
};
export default useEstimateById;
